import $ from 'jquery';
import gsap from 'gsap';
import modular from 'modujs';

const {ScrollTrigger} = require('gsap/dist/ScrollTrigger');

import Utils from '../utils/utils';
import Cookiebar from '../interface/cookieBar';
import Menu from '../interface/menu';
import BulbPageTransition from './bulbPageTransition';
import * as modules from './bulbModulesList';
// import Cursor from '../interface/cursor';
import Navbar from '../interface/navbar';
import SplitTextEffect from '../utils/effects/splitTextEffect';
import MagneticButton from '../utils/effects/magneticButton';

import BulbScroll from './bulbScroll';
import { MorphSVGPlugin } from '../vendors/gsap/MorphSVGPlugin';
import SiteLoader from '../interface/siteLoader';
import SearchBar from "../interface/searchBar";


/**
 * Bulb Micro "Framework"
 */
class Bulb {

    constructor()
    {

        Utils.copyrights();
        Utils.debug('Construct Bulb');

        this.name = 'Bulb web starter';
        this.version = '2.0';
        this.dev = true;

        this.hash = null;
        // les différents container dont nous aurons besoin
        this.$app = $('#app');
        this.$main = document.querySelector(".main")

        this.options = {
            useTicker: false,
            useScrollEffects: true,
            usePageTransition: true,
            useCursor: false,
            usePreloadImage: true,
        };
        if (Utils.isIE() || Utils.isMobile()) {
            this.options.useCursor = false
        }
        gsap.registerPlugin(ScrollTrigger);
        gsap.registerPlugin(MorphSVGPlugin);

        this.init();
    }


    /**
     *
     */
    init()
    {
        Utils.debug('Bulb init');
        this.initEvents();

        new SplitTextEffect();
        new Navbar();
        new MagneticButton();
        new SearchBar();
        // new LoadMore();

        if (Utils.isTouch()) {
            this.$app.addClass('touch')
        }

        this.getDevice()
        // gestion des modules
        this.modules = new modular({
            modules: modules,
        });
        this.modules.init(this.modules);

        // Launch cursor
        if (this.options.useCursor) {
            // TODO : rajouter des options au curseur pour forcer l'ajout de data lié
            let $linkToAddCursor = document.querySelectorAll('.footer__container__row__left__bloc a, .newsletter-submitBtn, footer nav a');
            $linkToAddCursor.forEach((elt) => {
                elt.setAttribute('data-bulb-cursor', 'link')
            });

            this.cursor = new Cursor({
                pointerEffect : 'deformation' ,
                trackerDisplay : true, // boolean
                pointerDisplay : true, // boolean
            });
        }

        // Lancement du ticker au besoin
        if (this.options.useTicker) {
            this.ticker();
        }

        // utilisation d'une librairie de scroll "locomotive"
        if (this.options.useScrollEffects) {
            this.scroll = new BulbScroll(this);
        }


        // gestion des transition entre les page (barbaJs)
        if (this.options.usePageTransition) {
            this.pageTransition = new BulbPageTransition(this)
        }

        // tous les composant qui sont chargés quoi qu'il arrive
        new Cookiebar();
        new Menu();

        window.addEventListener('orientationchange', () => {
            document.location.reload();
        }, false);

        let siteLoader = new SiteLoader()
        siteLoader.preloadAsset()

        if( Utils.getCookie('cookieBar') === 'yes'){
          this.trackerInit();
        }
    }


    getDevice() {
    }

    getColor() {
      let color = document.querySelector('[data-color]');
      if (color) {
        this.$main.style.color = color.dataset.color
      }

    }

  /**
   *
   */
  trackerRemove(){
      if(document.querySelector('#googleTrackingScript')){
        document.querySelector('#googleTrackingScript').remove()
        window['ga-disable-G-YD393ELNW0'] = true;
        window['ga-disable-UA-195425254-1'] = true;
      }
    }


    gtag(){
      dataLayer.push(arguments);
    }

  /**
   *
   */
  trackerInit()
    {

        console.debug('---> Tracker INIT');


        window['ga-disable-G-YD393ELNW0'] = false;
        window['ga-disable-UA-195425254-1'] = false;

        var scriptTag = document.createElement('script');
        scriptTag.id = 'googleTrackingScript';
        scriptTag.src = 'https://www.googletagmanager.com/gtag/js?id=G-YD393ELNW0';
        scriptTag.onload = () => {
            window.dataLayer = window.dataLayer || [];
            this.gtag('js', new Date());
            this.gtag('config', 'G-YD393ELNW0');
        };
        document.body.appendChild(scriptTag);
    }


    trackPageView()
    {

      console.debug('---> trackPageView');
      this.gtag('config', 'UA-195425254-1', {
        'page_title' : document.title,
        'page_path': document.location.pathname
      });
      // dataLayer.push('event', 'page_view', { 'send_to': 'UA-195425254-1' });
      // dataLayer.push('config', 'UA-195425254-1');

      // gtag('config', 'G-YD393ELNW0');

      // if(typeof gtag === "function"){
      //   gtag('config', 'UA-195425254-1');
      // }

      // if(typeof ga === "function"){
      //   console.debug('---> on track --> title : + '+ document.location.pathname + ' || page : ' + document.title);
      //   ga('set', 'page',  document.location.pathname);
      //   ga('set', 'title', document.title);
      //   ga('send', 'pageview');
      // }
    }

    /**
     *
     */
    initEvents()
    {
        Utils.debug('initEvents');

        this.resizeHandler();
        $(window).on('resize orientationchange', this.resizeHandler());
    }

    /**
     * Todo : debounce la fonction
     * On mettra ici tout ce qui est propre au resize du site
     */
    resizeHandler()
    {
        //this.debug('resizeHandler');
    }


    /**
     * Todo : vérifier le ticker
     */
    ticker()
    {
        //console.debug('Ticker');
        requestAnimationFrame(this.ticker());
    }

}
export default Bulb;



// WEBPACK FOOTER //
// ./scripts/core/bulb.js